import {
    observable, action
} from 'mobx';

class EngineeringStore {
    @observable.shallow weekList = [];

    @action setWeekList(data) {
        this.weekList = data || [];
    }
}

export default new EngineeringStore();